// extracted by mini-css-extract-plugin
export default {"container":"IOPicsyCompleteStorePage-module__container--mG2jv","title":"IOPicsyCompleteStorePage-module__title--j3eRh","subtitle":"IOPicsyCompleteStorePage-module__subtitle--DaMNx"};